import styled from 'styled-components'
import { vimovaTheme } from '../../theme/vimovaTheme'

export const TwoColumnLayout = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 20px;

  @media print {
    display: flex !important;
    gap: 24px !important;
    margin-top: 20px !important;
  }
`

export const DescriptionColumn = styled.div`
  flex: 1;
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.text};
  line-height: 1.6;

  @media print {
    flex: 1 !important;
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const DescriptionSubtitle = styled.h3`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 8px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgencyPhotoArea = styled.div<{ $photoUrl?: string }>`
  width: 220px;
  height: 160px;
  border-radius: ${vimovaTheme.borderRadius.signature};
  background: ${({ $photoUrl }) =>
    $photoUrl
      ? `url(${$photoUrl}) center/cover no-repeat`
      : vimovaTheme.colors.backgroundMuted};
  flex-shrink: 0;

  @media print {
    width: 220px !important;
    height: 160px !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    background: ${({ $photoUrl }) =>
      $photoUrl
        ? `url(${$photoUrl}) center/cover no-repeat`
        : vimovaTheme.colors.backgroundMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ServicesSection = styled.div`
  margin-top: 24px;

  @media print {
    margin-top: 24px !important;
  }
`

export const ServicesSectionTitle = styled.h3`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 16px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ServiceCategoriesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 32px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 20px 32px !important;
  }
`

export const ServiceCategory = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 6px !important;
  }
`

export const ServiceCategoryTitle = styled.h4`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.body};
  color: ${vimovaTheme.colors.textDark};
  margin: 0 0 4px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.body} !important;
    color: ${vimovaTheme.colors.textDark} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ServiceItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: 8px !important;
  }
`

export const ServiceCheckmark = styled.div`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${vimovaTheme.colors.green};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media print {
    width: 18px !important;
    height: 18px !important;
    border-radius: 50% !important;
    background: ${vimovaTheme.colors.green} !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const ServiceText = styled.span`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.small};
  color: ${vimovaTheme.colors.text};

  @media print {
    font-size: ${vimovaTheme.fontSizes.small} !important;
    color: ${vimovaTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatsSection = styled.div`
  margin-top: 56px;

  @media print {
    margin-top: 56px !important;
  }
`

export const StatsSectionTitle = styled.h3`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.bold};
  font-size: ${vimovaTheme.fontSizes.medium};
  color: ${vimovaTheme.colors.primary};
  margin: 0 0 16px 0;

  @media print {
    font-weight: ${vimovaTheme.fontWeights.bold} !important;
    font-size: ${vimovaTheme.fontSizes.medium} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 12px;

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 12px !important;
  }
`

export const StatCard = styled.div`
  background: ${vimovaTheme.colors.backgroundWarm};
  border-radius: ${vimovaTheme.borderRadius.signature};
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 12px;

  @media print {
    background: ${vimovaTheme.colors.backgroundWarm} !important;
    border-radius: ${vimovaTheme.borderRadius.signature} !important;
    padding: 16px !important;
    display: flex !important;
    align-items: center !important;
    gap: 12px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatIconWrapper = styled.div`
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  @media print {
    width: 36px !important;
    height: 36px !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`

export const StatContent = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const StatValue = styled.div`
  font-family: ${vimovaTheme.fonts.heading};
  font-weight: ${vimovaTheme.fontWeights.black};
  font-size: ${vimovaTheme.fontSizes.large};
  color: ${vimovaTheme.colors.primary};

  @media print {
    font-weight: ${vimovaTheme.fontWeights.black} !important;
    font-size: ${vimovaTheme.fontSizes.large} !important;
    color: ${vimovaTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const StatLabel = styled.div`
  font-family: ${vimovaTheme.fonts.body};
  font-size: ${vimovaTheme.fontSizes.micro};
  color: ${vimovaTheme.colors.textMuted};
  margin-top: 2px;

  @media print {
    font-size: ${vimovaTheme.fontSizes.micro} !important;
    color: ${vimovaTheme.colors.textMuted} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
